<template>
  <div class="dm-ledger-rule fts-ledger-toggle-row">
    <div class="dm-ledger-rule-label" :title="helper">
      {{ label }}
    </div>
    <div class="dm-ledger-states" :class="{ 'ledger-toggle-states--locked': disabled }">
      <template v-for="(st, si) in states">
        <span class="dm-ledger-sep" v-if="si" :key="fieldName + 'sep' + si">·</span>
        <span
          class="dm-ledger-state"
          :class="{ 'dm-ledger-state--on': st.active }"
          @click="!st.active && set(st.val)"
          :key="fieldName + 'st' + si"
        >{{ st.label }}</span>
      </template>
    </div>
  </div>
</template>

<script>
/* A boolean activity setting as a two-state ledger row (Advanced tab, ruling 2026-08-10):
   leftmost = the default state, weight-not-hue. Writes the same true/false the old toggle
   switches wrote — payload identical. */
export default {
  props: {
    formData: { type: Object, required: true },
    fieldName: { type: String, required: true },
    label: String,
    helper: String,
    offLabel: { type: String, default: "Off" },
    onLabel: { type: String, default: "On" },
    // which state is the DEFAULT (renders leftmost). Most settings default off.
    defaultOn: Boolean,
    disabled: Boolean
  },
  computed: {
    value() {
      return Boolean(this.formData[this.fieldName]);
    },
    states() {
      const off = { label: this.offLabel, active: !this.value, val: false };
      const on = { label: this.onLabel, active: this.value, val: true };
      return this.defaultOn ? [on, off] : [off, on];
    }
  },
  methods: {
    set(val) {
      if (this.disabled) return;
      this.$set(this.formData, this.fieldName, val);
    }
  }
};
</script>

<style lang="scss">
.fts-ledger-toggle-row {
  .ledger-toggle-states--locked {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
